/**
 * SIGN IN WITH JUST THE NAME.
 *
 * "gaurav" signs in as gaurav@digitalpresencematters.com: when what was typed
 * has no "@", the agency's domain is added. A full address is left exactly as
 * typed (only trimmed), so client logins and other domains are unaffected.
 *
 * The server applies the same rule; doing it here too keeps "already signed in
 * as this person" checks and the saved account list in full addresses.
 */
export const DEFAULT_LOGIN_DOMAIN = 'digitalpresencematters.com';

export function toLoginEmail(value) {
  const typed = String(value ?? '').trim();
  if (!typed || typed.includes('@')) return typed;
  return `${typed.toLowerCase()}@${DEFAULT_LOGIN_DOMAIN}`;
}
